module.exports = __webpack_public_path__ + "static/media/more.88c1da91.svg";